import React from 'react';
import clsx from 'clsx';

import styles from './IconButton.module.scss';

export type IconButtonColor = 'blue' | 'grey' | 'destroy' | 'light' | 'nav';

export type IconButtonProps = {
  //icon?: string;
  iconComponent: React.ReactNode;
  /**
   * Applies the design-system colors for default, hover, pushed and disabled states.
   * Multicolor SVGs should set `data-icon-multicolor` on their root element.
   */
  color?: IconButtonColor;
  disabled?: boolean;
  /**
   * Indicates that the popup controlled by this button is open.
   * Keeps the button in its pushed color after pointer release and exposes
   * the state to assistive technologies through `aria-expanded`.
   * Use only for buttons that control expandable content.
   */
  expanded?: boolean;
  //iconClassName?: string;
  testId?: string;
  tooltip?: string;
  disabledTooltip?: string;
  // e.g. in IconDropDownButton we need to enable click propagation,
  // so that useTriggerOnClickOutsideElement works.
  // by default click propagation is disabled (so that the button works correctly in tables, e.g. MergeFieldList
  enableClickPropagation?: boolean;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'color'>;

export const IconButton = React.forwardRef<HTMLAnchorElement, IconButtonProps>(
  function IconButton(props, ref) {
    const {
      //icon,
      iconComponent,
      color,
      disabled,
      expanded,
      testId,
      className,
      onClick,
      enableClickPropagation,
      //iconClassName,
      tooltip,
      disabledTooltip,
      ...restProps
    } = props;

    return (
      <div title={disabled ? disabledTooltip : tooltip}>
        <a
          {...restProps}
          ref={ref}
          data-disabled={disabled || undefined}
          data-icon-color={color}
          data-expanded={expanded || undefined}
          aria-expanded={expanded}
          className={clsx(styles.iconButton, className)}
          data-test-id={testId}
          onClick={
            enableClickPropagation
              ? onClick
              : (e) => {
                  e.stopPropagation();
                  onClick?.(e);
                }
          }
        >
          {props.iconComponent}
        </a>
      </div>
    );
  },
);
/*
{props.iconComponent ? (
          props.iconComponent
        ) : props.icon ? (
          <img className={clsx(styles.image, iconClassName)} src={icon} />
        ) : null}
*/
